import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContactHelpRoutingModule } from './contact-help-routing.module';
import { ContactAndHelpComponent } from '../contact-help/components/contact-and-help/contact-and-help.component';

import { ContactCardComponent } from '../contact-help/components/contact-card/contact-card.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { SharedModule } from 'src/app/shared/shared.module';
import { ComponentsLibModule } from '@ccab/components-lib';
import { FaqComponent } from './components/faq/faq.component';
import { ContactHelpComponent } from './components/contact-help/contact-help.component';
import { ContactHelpNavbarComponent } from './components/contact-help-navbar/contact-help-navbar.component';

@NgModule({
  declarations: [ContactAndHelpComponent, ContactCardComponent, FaqComponent, ContactHelpComponent, ContactHelpNavbarComponent],
  imports: [CommonModule, ContactHelpRoutingModule, FormsModule, MatSortModule, SharedModule, ComponentsLibModule, ReactiveFormsModule]
})
export class ContactHelpModule {}
